import styled from 'utils/emotion';

export const VideoStyled = styled('video')({
  width: '100%',
});
